import React from "react";
import { Link } from "react-router-dom";

function PageHeader({ title, subtitle, action, breadcrumbs = [] }) {
  return (
    <div className="page-header">
      <div className="page-header-copy">
        {breadcrumbs.length ? (
          <div className="page-breadcrumbs">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={`${crumb.label}-${index}`}>
                {index > 0 ? <span className="page-breadcrumb-separator">/</span> : null}
                {crumb.to ? (
                  <Link className="page-breadcrumb-link" to={crumb.to}>
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="page-breadcrumb-current">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        ) : null}
        <div className="page-header-title-row">
          {!breadcrumbs.length ? <p className="page-eyebrow">Workspace</p> : null}
          <h2 className="page-title">{title}</h2>
        </div>
        {subtitle ? <div className="page-subtitle">{subtitle}</div> : null}
      </div>
      {action ? <div className="page-header-action">{action}</div> : null}
    </div>
  );
}

export default PageHeader;
